export const TRANSACTION_HISTORY_GET_TRANSACTION_HISTORY = 'TRANSACTION_HISTORY_GET_TRANSACTION_HISTORY';
export const TRANSACTION_HISTORY_SET_HISTORY = 'TRANSACTION_HISTORY_SET_HISTORY';
